export const frHeader = {
    'commons.header.menu.logout': 'Se déconnecter',
    'commons.header.dialog.title': 'Déconnexion',
    'commons.header.dialog.content': 'Êtes-vous sur de vouloir vous déconnecter ?',
    'commons.header.dialog.cancel': 'Annuler',
    'commons.header.dialog.logout': 'Se déconnecter',
};
